import { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { Notification } from '@components';
import DownloadProgressPanel from '@components/download-progress-panel/DownloadProgressPanel';

import { store } from '../core/store';

type AppProviderProps = {
  children: ReactNode;
};

const AppProvider = ({ children }: AppProviderProps) => (
  <Provider store={store}>
    <HelmetProvider>
      <Notification />
      <DownloadProgressPanel />
      <Router>{children}</Router>
    </HelmetProvider>
  </Provider>
);

export default AppProvider;
